import React, { useEffect, useState } from "react";
//@ts-ignore
import logo from "../assets/images/logo-light.svg";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
    }
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  return (
    <div
      className={`customHeader ${mobileMenuOpen ? "active" : ""} ${
        isScrolled ? "blurryHeader" : ""
      }`}
    >
      <nav className={`inner`}>
        <a href="/" className="logo">
          <img src={logo} alt="Logo" />
        </a>
        <ul className="main-menu">
          <li>
            <a
              href={"/"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href={"/despre-noi"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Despre Noi
            </a>
          </li>
          <li>
            <a
              href={"/#servicii"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Servicii
            </a>
          </li>
          {/* <li>
            <a
              href={"/#projects"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Proiecte
            </a>
          </li> */}
          <li>
            <a
              href={"/blog"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Blog
            </a>
          </li>
          <li>
            <a
              href={"/#contact"}
              onClick={() => setMobileMenuOpen(false)}
              className="nav-link"
            >
              Contact
            </a>
          </li>
        </ul>
        <div className="right-menu">
          <a
            href="https://www.instagram.com/asempera.ro/"
            target="_blank"
            className="special-button22"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          {/* <a href="https://www.facebook.com/profile.php?id=61579049427161" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a> */}
          <a href={`https://wa.me/40758928165`} className="special-button22">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
          <a href={`tel:+40758928165`} className="special-button22">
            <i className="fas fa-phone"></i>
          </a>

          {/* <div className="special-button">Get started</div> */}
        </div>

        <div className="mobile-trigger" onClick={toggleMobileMenu}>
          <i className="fas fa-bars"></i>
        </div>
        <div className="mobile-close" onClick={toggleMobileMenu}>
          <i className="fas fa-times"></i>
        </div>
      </nav>
    </div>
  );
}
